import React from 'react';
import { noMoreLines, organizedItems } from '../data/content';
export function ProblemSection() {
  return <section className="w-full" data-id="element-172" data-mp="2lt32yleebjbs">
      <div className="w-full bg-slate-100 px-5 py-12 sm:py-14" data-id="element-173" data-mp="2lu4mzfde3g5n">
        <div className="mx-auto max-w-[760px] text-center" data-id="element-174" data-mp="30i99kufkcbtp">
          <h2 className="text-balance text-[1.6rem] font-extrabold uppercase leading-[0.95] tracking-tight text-slate-950 sm:text-[2rem]" data-id="element-175" data-mp="2vqhfwb141pzc">
            Stop Planning Every Financial Literacy Lesson From Scratch
          </h2>
          <p className="mt-4 text-[1rem] leading-relaxed text-slate-950 sm:text-[1.05rem]" data-id="element-176" data-mp="35gu1m6knvp72">
            New topic? Different student levels? Budgeting? Banking? Paychecks?
            Credit? Saving? Investing? Taxes? Real-life money decisions?
          </p>
          <p className="mt-2 text-[1.05rem] font-extrabold text-slate-950" data-id="element-177" data-mp="3eew9n62tbi3u">
            Where do you even start?
          </p>
          <p className="mt-4 text-[1rem] leading-relaxed text-slate-950 sm:text-[1.05rem]" data-id="element-178" data-mp="1k37oun9wglbj">
            <strong className="font-extrabold" data-id="element-179" data-mp="jddeqewpsoyp">FINANCIAL LITERACY READY™</strong>{' '}
            gives you a complete, structured system so you can prepare your
            classes in less time and follow a clear progression throughout the
            school year.
          </p>
          <ul className="mt-5 space-y-1.5" data-id="element-180" data-mp="sbytdyz2fju7">
            {noMoreLines.map(line => <li key={line} className="text-[1rem] font-semibold text-slate-800 sm:text-[1.05rem]" data-id="element-181" data-mp="x5tdh3il20tt">
                {line}
              </li>)}
          </ul>
          <p className="mt-5 text-[1.1rem] font-extrabold uppercase tracking-tight text-orange-700" data-id="element-182" data-mp="174iqoizjax3q">
            Choose. Open. Teach.
          </p>
        </div>
      </div>

      <div className="w-full bg-white px-5 py-12 sm:py-14" data-id="element-183" data-mp="1g2l11p55r23o">
        <div className="mx-auto max-w-[760px] rounded-lg border-l-[6px] border-orange-500 bg-slate-100 p-6 text-left sm:p-8" data-id="element-184" data-mp="3dtxgzzmehgef">
          <h3 className="text-[1.1rem] font-extrabold uppercase leading-[0.95] tracking-tight text-slate-950 sm:text-[1.4rem]" data-id="element-185" data-mp="3hv97s8h0g7o7">
            Stop Searching for Materials in Ten Different Places
          </h3>
          <p className="mt-3 text-[1rem] font-bold text-slate-950 sm:text-[1.05rem]" data-id="element-186" data-mp="k30gdjq8usa4">
            You already know how to teach.
          </p>
          <p className="mt-2 text-[1rem] leading-relaxed text-slate-950 sm:text-[1.05rem]" data-id="element-187" data-mp="tzlkm2ufvzcw">
            The problem is the amount of time you lose searching online,
            creating worksheets, designing activities, writing assessments, and
            trying to turn random resources into a coherent curriculum.
          </p>
          <p className="mt-3 text-[1rem] leading-relaxed text-slate-950 sm:text-[1.05rem]" data-id="element-188" data-mp="1hnwhkux0levw">
            With{' '}
            <strong className="font-extrabold" data-id="element-189" data-mp="1cqd5a0jvnc6l">FINANCIAL LITERACY READY™</strong>
            , you open the system, choose the topic, and everything is already
            organized for you.
          </p>
          <ul className="mt-4 flex flex-wrap gap-1.5" data-id="element-190" data-mp="1ls45ipvneqt2">
            {organizedItems.map(item => <li key={item} className="rounded-md bg-white px-2.5 py-1 text-[0.9rem] font-semibold text-slate-950" data-id="element-191" data-mp="25d4fn4o0riiq">
                {item}.
              </li>)}
          </ul>
          <p className="mt-5 text-[1rem] font-extrabold text-slate-950 sm:text-[1.05rem]" data-id="element-192" data-mp="20d8a30zobj12">
            Less preparation. More teaching.
          </p>
        </div>
      </div>
    </section>;
}